// extracted by mini-css-extract-plugin
export default {"slideStyling":"PurposeSlide_slideStyling__Ba9HC"};